{
  "status": {
    "overdue": "OVERDUE"
  },
  "actions": {
    "create_task": "Create Task",
    "update_task": "Update Task"
  },
  "form": {
    "labels": {
      "due_date": "Due Date",
      "assigned_to": "Assigned To",
      "requested_by": "Requested By",
      "description": "Description"
    },
    "placeholders": {
      "assigned_to": "assigned to",
      "requested_by": "requested by"
    },
    "validation": {
      "task_required": "Please enter a task",
      "date_too_old": "that's too long ago",
      "date_too_far": "that's too far away",
      "task_name_empty": "Task name cannot be empty",
      "unexpected_error": "An unexpected error occurred while adding the task."
    }
  },
  "table": {
    "headers": {
      "tasks": "Tasks",
      "priority": "Priority",
      "due_date": "Due Date",
      "assigned_to": "Assigned To",
      "source": "Source"
    }
  },
  "delete": {
    "confirmation_message": "Click confirm to delete task"
  },
  "aria_labels": {
    "create_new_task": "create new task"
  },
  "slide": {
    "labels": {
      "due_date": "Due Date",
      "source": "Source",
      "assigned_to": "Assigned To",
      "requested_by": "Requested By",
      "completed_by": "Completed By",
      "description": "Description",
      "comments": "Comments"
    }
  },
  "sections": {
    "completed": "Completed"
  },
  "empty_state": {
    "title": "No Tasks Yet",
    "description": "Start by creating a task and organizing your work"
  },
  "display": {
    "empty_value": "-"
  },
  "partials_form": {
    "labels": {
      "associated_company": "Associated Company",
      "contact": "Contact",
      "task": "Task",
      "due_date": "Due Date",
      "assign_to": "Assign To"
    },
    "placeholders": {
      "associated_company": "Associated Company",
      "contact": "Contact",
      "describe_task": "Describe the task"
    },
    "validation": {
      "company_required": "please enter a company",
      "task_required": "Please enter a task",
      "date_too_old": "that's too long ago",
      "date_too_far": "that's too far away"
    },
    "buttons": {
      "add_task": "+ Task"
    },
    "modal": {
      "create_title": "Create Task",
      "update_title": "Update Task"
    }
  }
}
